<template>
  <div :class="[$style.card, { [$style.yellow]: isFirst }]">
    <div :class="$style.main">
      <div :class="$style.top">
        <div :class="$style.number">{{ order.number }}</div>
        <div :class="$style.time">
          {{ formatTime(order.planned_at) }}
        </div>
        <div :class="$style.workTime">
          <img
            src="/icons/clock-mini.svg"
            alt=""
            :class="[$style.clock, { [$style.clockBlack]: isFirst }]"
          />
          {{ executionMinutes }}
        </div>
      </div>

      <div
        v-if="clientLabel || order.car?.number"
        :class="$style.bottom"
      >
        <div :class="$style.make">
          <div v-if="showCarMakeLogo" :class="$style.icon">
            <img :src="order.car?.make?.logo" alt="" :class="$style.img" />
          </div>
          {{ clientLabel }}
        </div>
        <div :class="$style.number">
          {{ order.car?.number || "---------" }}
        </div>
      </div>
    </div>
    <div v-if="isFirst" :class="$style.offers">
      <div
        v-for="item in order.offers"
        :key="item.offer"
        :class="[$style.offer, { [$style.done]: item.offer_executed }]"
      >
        <div>{{ item.offer.title }}</div>
        <div :class="$style.quantity">x{{ item.wheels_quan }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime } from "@/utils/date";

export default {
  name: "OrderCard",
  props: {
    order: {
      type: Object,
      required: true,
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    clientLabel() {
      return this.order.car?.make?.title || "";
    },
    showCarMakeLogo() {
      return Boolean(this.order.car?.make?.logo);
    },
    executionMinutes() {
      const value = this.order?.execution_time;
      if (!value) return "";

      const parts = String(value).split(":");
      if (parts.length < 2) return value;

      const hours = Number(parts[0]) || 0;
      const minutes = Number(parts[1]) || 0;

      return String(hours * 60 + minutes).padStart(2, "0");
    },
  },
  methods: {
    formatTime,
  },
};
</script>

<style lang="scss" module>
.card {
  box-shadow: 1px 2px 12px 0px #0000003d;
  background-color: $bg-white;
  border-radius: 1rem;
  min-width: 0;
  min-height: 0;
  max-width: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &.yellow {
    background-color: $yellow;
  }

  .main {
    flex-shrink: 0;
    padding: 1rem;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      font-size: 2.25rem;
      font-weight: 600;

      .workTime {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        .clockBlack {
          filter: brightness(0);
        }
      }
    }

    .bottom {
      margin-top: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      font-size: 2.25rem;
      font-weight: 600;

      .make {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        .icon {
          flex-shrink: 0;
          border-radius: 50%;
          overflow: hidden;
          .img {
            width: 2.5rem;
            height: 2.5rem;
            display: block;
            object-fit: cover;
          }
        }
      }
      .number {
        border: 1px solid $t-primary;
        background-color: $bg-white;
        border-radius: 2px;
        padding: 0.5rem;
        color: $t-primary;
      }
    }
  }

  .offers {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    font-weight: 600;
    font-size: 1.25rem;
    .offer {
      padding: 0.5rem 1rem;
      border-top: 1px solid $t-secondary;
      background-color: $bg-white;
      color: $t-secondary;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      &:first-child {
        border-top: 1px solid $bg-white;
      }
      &.done {
        background-color: $yellow;
        color: $t-primary;
        border-top: 1px solid $bg-white;
      }
    }
  }

  // .items {
  //   padding: 1rem 1.5rem 1.5rem 1.5rem;
  //   display: flex;
  //   flex-direction: column;
  //   gap: 1rem;
  //   min-width: 0;
  //   background-color: $gr-order-items;
  //   &.isDone {
  //     background-color: $yellow;
  //   }
  //   .item {
  //     display: grid;
  //     grid-template-columns: minmax(0, 1fr) auto;
  //     align-items: center;
  //     gap: 0.5rem;
  //     min-width: 0;
  //     font-size: 2.25rem;
  //     font-weight: 600;
  //     color: $t-primary;
  //     .title {
  //       min-width: 0;
  //       overflow: hidden;
  //       white-space: nowrap;
  //       text-overflow: ellipsis;
  //     }
  //     .value {
  //       white-space: nowrap;
  //     }
  //   }
  // }
}
</style>
